<template>
  <div id="app" class="hua_xiaofang_all_wrap">
    <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'App',
  components: {

  }
}
</script>

<style>

</style>
